import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo } from "react";
import { ErrorPageContent } from "@ploy-ui/core";
import { addRegisteredSectionLayout } from "../sectionLayoutDescriptions";
import { useDispatch, useVariableData } from "@ploy-lib/calculation";
import { ErrorHandler } from "@ploy-lib/core";
import ClearIcon from "@material-ui/icons/Clear";
import { Grid, IconButton, lighten, makeStyles, Paper, Typography } from "@material-ui/core";
import { defineMessages } from "react-intl";
import clsx from "clsx";
import { useIntl } from "react-intl";
import { propertyMessage } from "@ploy-lib/types";
addRegisteredSectionLayout({
    name: "SimplifiedPropertiesSection",
    displayName: "SimplifiedPropertiesSection",
    settings: {
        editableOptions: {}
    }
});
const useStyles = makeStyles(theme => ({
    root: {},
    cardBorder: {
        borderColor: theme.palette.secondary.main
    },
    selectedCard: {
        backgroundColor: lighten(theme.palette.secondary.main, 0.9)
    },
    simpleSpacing: {
        padding: theme.spacing(1)
    },
    centerButton: {
        textAlign: "center"
    },
    removeButton: {},
    listTitle: {}
}), { name: "DploySimplifiedPropertiesSection" });
const messages = defineMessages({
    weFoundPropertySingularTitle: {
        id: "template-form.property.weFoundPropertySingularTitle",
        defaultMessage: "We found this property:"
    },
    weFoundPropertyPluralTitle: {
        id: "template-form.property.weFoundPropertyPluralTitle",
        defaultMessage: "We found these properties:"
    },
    removeProperty: {
        id: "template-form.property.removeProperty",
        defaultMessage: "Remove property"
    }
});
/* Pad postal codes less than 4 digits (because the leading 0s are stripped)
    e.g.: "375" => "0375" */
const padPostalCode = (postalCode) => {
    if (!postalCode)
        return "";
    if (postalCode.length === 4)
        return postalCode;
    return postalCode.padStart(4, "0");
};
const SingleProperty = (props) => {
    const styles = useStyles();
    const intl = useIntl();
    const { property, onRemove } = props;
    return (_jsx(Paper, { variant: "outlined", className: clsx(styles.cardBorder, {
            [styles.selectedCard]: property.refinance
        }), children: _jsxs(Grid, { container: true, alignItems: "center", alignContent: "center", justifyContent: "center", className: styles.simpleSpacing, children: [_jsx(Grid, { item: true, xs: 10, className: styles.simpleSpacing, children: _jsxs(Grid, { container: true, direction: "column", justifyContent: "space-between", spacing: 1, children: [_jsxs(Grid, { item: true, children: [_jsx(Typography, { variant: "h4", children: intl.formatMessage(propertyMessage[property.type]) }), property.type !== "Project" ? (_jsxs(Typography, { variant: "body1", children: [property.type === "Cadastre"
                                                ? property.cadastralNumber.replaceAll(/-/g, "/")
                                                : null, property.type === "Share" ? (_jsxs(_Fragment, { children: [property.housingCooperativeName, _jsx("br", {}), property.housingCooperativeOrgNumber, _jsx("br", {}), property.shareNumber] })) : null, property.type === "Stock" ? (_jsxs(_Fragment, { children: [property.housingCooperativeOrgName, _jsx("br", {}), property.apartmentNumber, _jsx("br", {}), property.businessManager] })) : null] })) : null] }), _jsxs(Grid, { item: true, children: [property.streetName ||
                                        property.addressNumber ||
                                        property.addressLetter ||
                                        property.postalCode ||
                                        property.postalPlace ? (_jsxs(Typography, { variant: "body1", children: [property.streetName, " ", property.addressNumber, " ", property.addressLetter, _jsx("br", {}), padPostalCode(property.postalCode), " ", property.postalPlace] })) : null, property.type === "Project" ? (_jsx(Typography, { variant: "body1", style: { whiteSpace: "pre-wrap" }, children: property.freeText?.trim() })) : null] })] }) }), _jsx(Grid, { item: true, xs: 2, className: styles.centerButton, children: _jsx(IconButton, { onClick: () => onRemove(property), title: intl.formatMessage(messages.removeProperty), children: _jsx(ClearIcon, {}) }) })] }) }));
};
const SimplifiedPropertiesSectionInternal = memo((props) => {
    const styles = useStyles(props);
    let { value: properties } = useVariableData("Calculator", "PROPERTIES");
    if (typeof properties === "string")
        properties = [];
    const dispatch = useDispatch();
    const intl = useIntl();
    const onRemoveProperty = useCallback((property) => {
        const newProperties = [...(properties ?? [])].filter(p => p.uniquePropertyId !== property.uniquePropertyId);
        dispatch({
            type: "patch",
            payload: {
                patches: [
                    {
                        target: "PROPERTIES",
                        namespace: "Calculator",
                        value: [...newProperties],
                        overwrite: true
                    }
                ]
            }
        });
    }, [dispatch, properties]);
    var propertyCards = useMemo(() => properties?.map(p => {
        return (_jsx(Grid, { item: true, xs: 12, children: _jsx(SingleProperty, { property: p, onRemove: onRemoveProperty }) }, p.uniquePropertyId));
    }), [onRemoveProperty, properties]);
    const somePropertyIsMainResidence = properties?.some(p => p.mainCustomerResidence);
    if (somePropertyIsMainResidence ||
        propertyCards == null ||
        propertyCards.length === 0) {
        return null;
    }
    return (_jsxs(Grid, { container: true, spacing: 1, className: clsx(styles.root, props.className), onClick: props.onClick, children: [_jsx(Typography, { variant: "h3", className: styles.listTitle, children: propertyCards.length > 1
                    ? intl.formatMessage(messages.weFoundPropertyPluralTitle)
                    : intl.formatMessage(messages.weFoundPropertySingularTitle) }), propertyCards] }));
});
const SimplifiedPropertiesSection = (props) => (_jsx(ErrorHandler, { fallback: e => (_jsx(ErrorPageContent, { className: props.className, onClick: props.onClick, header: _jsxs("span", { children: [SimplifiedPropertiesSection.displayName, " failed to render."] }) })), children: _jsx(SimplifiedPropertiesSectionInternal, { ...props }) }));
SimplifiedPropertiesSection.displayName = "SimplifiedPropertiesSection";
export { SimplifiedPropertiesSection };
//# sourceMappingURL=SimplifiedPropertiesSection.js.map